import { createFileRoute, useParams } from "@tanstack/react-router";

import { RenderContentProps } from "@/routes/_staff/certification/-shared";

import {
  AttributeRenderer,
  SectionFormWrapper,
  useGetPersonSpecialtyCertificationDetail,
  useUpdatePersonSpecialtyCertificationDetail,
} from "../../../../-shared";

export const Route = createFileRoute(
  "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/",
)({
  component: PersonSpecialtyCertificationDetail,
});

function PersonSpecialtyCertificationDetail() {
  const { id, personCertificationInformationId } = useParams({
    from: "/_staff/person/$id/certifications/specialty-certifications/$personCertificationInformationId/_layout/_index/",
  });

  return (
    <SectionFormWrapper
      useGetDetailQuery={useGetPersonSpecialtyCertificationDetail(
        id,
        personCertificationInformationId,
      )}
      useSaveMutation={useUpdatePersonSpecialtyCertificationDetail(
        id,
        personCertificationInformationId,
      )}
      renderContent={({ section }: RenderContentProps) => (
        <AttributeRenderer
          attributes={section.attributes}
          sectionKey={String(section.sectionKey)}
        />
      )}
    />
  );
}
